module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This book is for the Holdsworths of Sunset House")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication-space-before"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Memory of Richard (May 26, 1950–November 28, 2007)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d2316a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HowMidsummerNight.vue
// module id = 66
// module chunks = 0